import { render } from "./QuizDynamicResults.vue?vue&type=template&id=4d01a001"
import script from "./QuizDynamicResults.vue?vue&type=script&lang=js"
export * from "./QuizDynamicResults.vue?vue&type=script&lang=js"

import "./QuizDynamicResults.vue?vue&type=style&index=0&id=4d01a001&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__